
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-library/latest-videos",
      function () {
        return require("private-next-pages/content-library/latest-videos.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-library/latest-videos"])
      });
    }
  